export default {
  tags: {
    type: Array,
    default: () => []
  },
  placeholder: {
    type: String,
    default: ''
  },
  readOnly: {
    type: Boolean,
    default: false
  },
  validate: {
    type: String | Function | Object,
    default: ''
  },
  addTagOnKeys: {
    type: Array,
    default: function () {
      return [
        13,   // Return
        188,  // Comma ','
        9     // Tab
      ]
    }
  },
  addTagOnBlur: {
    type: Boolean,
    default: false
  },
  limit: {
    type: Number,
    default: 15
  },
  allowDuplicates: {
    type: Boolean,
    default: false
  },
  professionalTags: {
    type: Array,
    default: () => []
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/company/companies/components/tags/resources/props.js